
import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useStoreNavigate } from '@/hooks/use-app-navigate';

interface UpsellResourceBadgeProps {
    upsellId: string;
    variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    className?: string;
}

export function UpsellResourceBadge({
    upsellId,
    variant = 'secondary',
    className,
}: UpsellResourceBadgeProps) {
    const { storeRoutes } = useStoreNavigate();
    // Format display value based on available data
    const displayValue = React.useMemo(() => {
        return `${upsellId.substring(0, 8)}...`;
    }, [upsellId]);

    return (
        <ResourceBadge
            name="variant"
            value={displayValue}
            appLink={storeRoutes.UPSELL_EDIT(upsellId)}
            variant={variant}
            className={className}
        />
    );
}
